var render = function render(){var _vm=this,_c=_vm._self._c;return _c('entity-select-dialog',{ref:"entitySelectDialog",attrs:{"search":_vm.search,"items":_vm.items,"loading":_vm.loading},scopedSlots:_vm._u([{key:"listItem",fn:function(props){return [_c('part-list-item',{attrs:{"item":props.item,"row-click-enabled":true,"showActions":false}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }